export default __webpack_public_path__ + "media/images/theme_apple/blueButton-2942e414f0debe1678d820a10f09a693.png";